import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { AddCall } from 'src/providers/addvCall';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/providers/common';
@Component({
  selector: 'app-speciality',
  templateUrl: './speciality.page.html',
  styleUrls: ['./speciality.page.scss'],
})
export class SpecialityPage implements OnInit, OnDestroy {

  private apiSubscriptions: Subscription[] = [];


  specialityList: any;
  physiospecialityList: any;
  totalSkeleten = [];
  getSearchValue: any = "";
  URL: string;
  spclSrch: any;

  dynClass: any;
  isSearch: boolean;
  srchCont = [];
  srchContPhysio = [];
  loadEvnt: any;
  present: any;
  lattitude: number;
  longititude: number;
  spclListReq: any;
  Speciality: any;
  defaultImage = 'assets/img/Vector.png';
  specialityType: any;

  constructor(
    public router: Router,
    private services: ServicesProvider,
    public modalCtrl: ModalController,
    public activeRoute: ActivatedRoute,
    private geolocation: Geolocation,
    public addCall: AddCall,
    private platform: Platform,
    public common: CommonService
  ) { }
  public commonAnd = CommonService;

  ngOnInit() {
    this.getSearchValue = "";
    for (let i = 1; i <= 30; i++) {
      this.totalSkeleten.push(i);
    }
  }

  doRefresh(event) {
    this.loadEvnt = event;
    this.getSearchValue = "";
    this.srchCont = [];
    this.srchContPhysio = [];
    this.getDoctorSpeciality();
    this.getPhysioDoctorSpeciality();
  }
  refFunc() {
    if (this.loadEvnt) {
      this.loadEvnt.target.complete();
    }
  }

  onImageErrors(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImage;
  }

  ionViewWillEnter() {
    debugger;
    this.getSearchValue = "";
    this.Speciality = '';
    this.specialityType = '';
    this.Speciality = this.activeRoute.snapshot.paramMap.get('doctorlist');
    this.Speciality = this.activeRoute.snapshot.paramMap.get('physiodoctorlist');
    this.Speciality = this.activeRoute.snapshot.paramMap.get('speciality_name');
    this.specialityType = this.activeRoute.snapshot.paramMap.get('specialityType');
    if (this.Speciality == null || this.Speciality == 'Doctor') {
      this.Speciality = 'Doctor';
    }
    this.URL = 'http://localhost:8000';///this.services.API_URL;
    let searchCont = this.activeRoute.snapshot.paramMap.get('searchCont');
    debugger;
    console.log(this.specialityType,"------specialityType--------");
    
    if (searchCont) {
      this.present = "spclDoc";
      this.isSearch = true;
      this.getSearchValue = searchCont;
      try {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000
        };
        this.geolocation.getCurrentPosition(options).then((resp) => {
          this.lattitude = resp.coords.latitude;
          this.longititude = resp.coords.longitude;
          if(this.specialityType == 'Physio'){
            this.searchPhysioDS();
          }else{
            this.searchDS();
          }
        }, err => {
          this.lattitude = 29.62107798734671;
          this.longititude = 47.587719496877924;
          if(this.specialityType == 'Physio'){
            this.searchPhysioDS();
          }else{
            this.searchDS();
          }
          console.log('Error getting location', err);
        });
      } catch (e) {
        console.log(e);
      }     
    } else {
      this.present = "";
      this.isSearch = false;
      this.getSearchValue = "";
      if (this.Speciality == 'Physio') {
        this.getPhysioDoctorSpeciality();
      } else {
        this.getDoctorSpeciality();
      }
    }
    if (this.platform.is("android")) {
      try {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000
        };
        this.geolocation.getCurrentPosition(options).then((resp) => {
          this.commonAnd.setAndLat(resp.coords.latitude ?? 29.62107798734671);
          this.commonAnd.setAndLong(resp.coords.longitude ?? 47.587719496877924);
        }, err => {
          this.commonAnd.setAndLat(29.62107798734671);
          this.commonAnd.setAndLong(47.587719496877924);
          console.log('Error getting location', err);
        });
      } catch (e) {
        console.log('Speciality page geolocation', e);
      }
    }
    // if(this.specialityType == 'Physio'){
    //   this.searchPhysioDS();
    // }else{
    //   this.searchDS();
    // }
  }

  backToProfile() {
    this.router.navigate(['/tabs/home']);
  }

  openSpecialistDocList(specid, specname, type) {
    debugger
    console.log(specname, "=====specname");
    window.localStorage['specid'] = specid;
    window.localStorage['speciname'] = specname;
    window.localStorage['specitype'] = type;

    console.log(window.localStorage['specid'], "=======", window.localStorage['speciname'], "=======", window.localStorage['specitype']);


    localStorage.setItem("specId", specid);
    if (this.platform.is("ios")) {
      if (type == 'Physio') {
        this.router.navigate(['/tabs/physio-doctors-list', { id: specid, speciname: specname, frmSplHome: false }]);
      } else {
        this.router.navigate(['/tabs/doctors-list', { id: specid, speciname: specname, frmSplHome: false }]);
      }
    } else {
      if (type == 'Physio') {
        this.router.navigate(['/tabs/physio-doctors-list', { id: specid, speciname: specname, frmSplHome: false }]);
      } else {
        this.router.navigate(['/tabs/doctors-list', { id: specid, speciname: specname, frmSplHome: false}]);
      }
    }
  }

  goToDocDet(docID, ClinicID, dName,specialityID) {
    localStorage.setItem("fromPage", "speciality");
    window.localStorage['docName'] = dName;
    let date = new Date(Date.now());
    let searchDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
    this.router.navigate(['/tabs/doc-appointment', {
      doctorId: docID,
      clinicId: ClinicID,
      searchDate: searchDate,
      searchCont: this.getSearchValue,
      splid: specialityID,
      specialityType: 'Doctor'
    }]);
  }

  goToPhysioDocDet(docID, ClinicID, dName,specialityID) {
    localStorage.setItem("fromPage", "speciality");
    window.localStorage['docName'] = dName;
    let date = new Date(Date.now());
    let searchDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
    this.router.navigate(['/tabs/physio-doc-appointment', {
      doctorId: docID,
      clinicId: ClinicID,
      searchDate: searchDate,
      searchCont: this.getSearchValue,
      splid: specialityID,
      specialityType: 'Physio'
    }]);
  }


  getDoctorSpeciality() {

    try {
      if (this.spclListReq) {
        this.spclListReq.unsubscribe();
      }
      if (this.spclSrch) {
        this.spclSrch.unsubscribe();
      }
      this.present = "";
      let data = JSON.stringify({
        "speciality": "",
        "foldername": "specialityPath"
      })
      this.spclListReq = this.services.postRequestGndrl("admin/getdoctorspecialitylist", data).subscribe(res => {
        console.log(res);
        this.refFunc();
        this.specialityList = res;
        this.present = "spclList";
      }, err => {
        console.log(err);
        this.refFunc();
      });
      this.apiSubscriptions.push(this.spclListReq);
    } catch (err) {
      console.log(err);
      this.refFunc();
    }
  }

  getPhysioDoctorSpeciality() {

    try {
      if (this.spclListReq) {
        this.spclListReq.unsubscribe();
      }
      if (this.spclSrch) {
        this.spclSrch.unsubscribe();
      }
      this.present = "";
      let data = JSON.stringify({
        "speciality": "",
        "foldername": "specialityPath"
      })
      this.spclListReq = this.services.postRequestGndrl("admin/getphysiodoctorspecialitylist", data).subscribe(res => {
        console.log(res);
        this.refFunc();
        this.physiospecialityList = res;
        this.present = "spclPhysioList";
      }, err => {
        console.log(err);
        this.refFunc();
      });
      this.apiSubscriptions.push(this.spclListReq);
    } catch (err) {
      console.log(err);
      this.refFunc();
    }
  }

  searchDS() {
    try {
      if (!this.getSearchValue) {
        this.getDoctorSpeciality();
        this.isSearch = false;
      } else {
        if (this.lattitude && this.longititude) {
          this.searchAPI();
        } else {
          let options = {
            enableHighAccuracy: true,
            timeout: 5000
          };
          this.geolocation.getCurrentPosition(options).then((resp) => {
            this.lattitude = resp.coords.latitude;
            this.longititude = resp.coords.longitude;
            this.searchAPI();
          }, err => {
            this.lattitude = 29.62107798734671;
            this.longititude = 47.587719496877924;
            this.searchAPI();
            console.log('Error getting location', err);
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  searchPhysioDS() {
    try {
      if (!this.getSearchValue) {
        this.getPhysioDoctorSpeciality();
        this.isSearch = false;
      } else {
        if (this.lattitude && this.longititude) {
          this.searchPhysioAPI();
        } else {
          let options = {
            enableHighAccuracy: true,
            timeout: 5000
          };
          this.geolocation.getCurrentPosition(options).then((resp) => {
            this.lattitude = resp.coords.latitude;
            this.longititude = resp.coords.longitude;
            this.searchPhysioAPI();
          }, err => {
            this.lattitude = 29.62107798734671;
            this.longititude = 47.587719496877924;
            this.searchPhysioAPI();
            console.log('Error getting location', err);
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  }


  searchAPI() {
    try {
      this.specialityList = [];
      this.isSearch = true;
      this.present = "";
      if (this.spclListReq) {
        this.spclListReq.unsubscribe();
      }
      if (this.spclSrch) {
        this.spclSrch.unsubscribe();
      }
      let data = JSON.stringify({
        "search_text": this.getSearchValue,
        "lat": this.lattitude,
        "long": this.longititude
      });
      this.spclSrch = this.services.postRequestDoc("getDoctorSearchByName", data).subscribe(res => {
        console.log(res);
        this.srchCont = res.data;
        this.present = "spclDoc";
      }, err => {
        console.log(err);
      });
      this.apiSubscriptions.push(this.spclSrch);
    } catch (err) {
      console.log(err);
    }
  }

  searchPhysioAPI() {
    try {
      this.physiospecialityList = [];
      this.isSearch = true;
      this.present = "";
      if (this.spclListReq) {
        this.spclListReq.unsubscribe();
      }
      if (this.spclSrch) {
        this.spclSrch.unsubscribe();
      }
      let data = JSON.stringify({
        "search_text": this.getSearchValue,
        "lat": this.lattitude,
        "long": this.longititude
      });
      this.spclSrch = this.services.postRequestPhysioDoc("getPhysioDoctorSearchByName", data).subscribe(res => {
        console.log(res);
        this.srchContPhysio = res.data;
        this.present = "spclPhysioList";
      }, err => {
        console.log(err);
      });
      this.apiSubscriptions.push(this.spclSrch);
    } catch (err) {
      console.log(err);
    }
  }


  openAppointments() {
    this.router.navigate(['/tabs/appointments']);
  }

  ngOnDestroy() {
    this.apiSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
}
